/*-------------------
     モジュールのimport
 ---------------------*/
import React from 'react';
import { withRouter } from 'react-router';

/**
 * フッター作成
 */
const Footer = () => {
  const tagName = '20260903A';
  return (
    <p id="copy">
      <small>&copy;{`2020 CYBERLINKS CO.,LTD. ${tagName}`}</small>
    </p>
  );
};

export default withRouter(Footer);
